<div class="auth-body h-screen relative">
<div class="absolute bottom-0 w-full flex justify-center flex-row">
  <div class="p-4 w-full bg-white">
    <p class="text-center text-[#797C83] footer-branding"> A Product by <b><a target="_blank" href="https://purple.lk/" class=" text-[#797C83] hover:font-[#640D5C]" style="">Purple Software</a></b></p>
  </div>
</div>
  <div class="grid lg:grid-cols-2 h-full">
    <div class="bg-slate-200 hidden lg:flex items-center justify-end">
      <div class="bg-white h-4/6 w-8/12 p-1 drop-shadow-lg">
        <img
          class="h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1641759796228-2479fca98bf2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1174&q=80"
          alt="" />
      </div>
    </div>
    <div class="lg:bg-primary flex items-center justify-start">
      <div
        class="lg:bg-white w-full lg:h-4/6 lg:w-8/12 drop-shadow-lg flex items-center justify-center">
        <div class="w-8/12 lg:w-7/12 text-center lg:text-start">
          <nz-card class="border-0">
            <div class="mb-4">
            </div>
            <form nz-form [formGroup]="loginForm">
              <h3>Login</h3>
              <div class="flex flex-col items-stretch my-4">
                <nz-form-item class="mb-3">
                  <nz-form-control class="w-full" [nzErrorTip]="usernameError">
                    <nz-input-group nzPrefixIcon="user">
                      <input
                        nz-input
                        formControlName="email"
                        placeholder="Email" />
                    </nz-input-group>
                  </nz-form-control>
                  <ng-template #usernameError>
                    <span>Please enter email address</span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="mb-3">
                  <nz-form-control class="w-full" [nzErrorTip]="passwordError">
                    <nz-input-group
                      nzPrefixIcon="lock"
                      [nzSuffix]="PasswordSuffixTemplate">
                      <input
                        nz-input
                        [type]="passwordVisible ? 'password' : 'text'"
                        formControlName="password"
                        placeholder="Password"
                        required />
                    </nz-input-group>
                    <ng-template #PasswordSuffixTemplate>
                      <i
                        class="cursor-on"
                        nz-icon
                        [nzType]="passwordVisible ? 'eye' : 'eye-invisible'"
                        (click)="passwordVisible = !passwordVisible"></i>
                    </ng-template>
                  </nz-form-control>
                  <ng-template #passwordError>
                    <span>Please enter password</span>
                  </ng-template>
                </nz-form-item>
                <div class="flex justify-end">
                  <a routerLink="/auth/forgot-password" class="text-sm"
                    >Forgot Password?</a
                  >
                </div>
              </div>
              <button
                nz-button
                nzType="primary"
                nzBlock
                (click)="onLogin()"
                [disabled]="loginForm.invalid">
                login
              </button>
              <div class="flex justify-center my-3">
                <p class="text-sm">
                  Don't you have account?
                  <a routerLink="/auth/registration" class="text-sm">Sign Up</a>
                </p>
              </div>
              <nz-alert
                class="mt-2"
                *ngIf="isError.status"
                nzType="error"
                [nzMessage]="isError.message"
                nzShowIcon></nz-alert>
            </form>
          </nz-card>
        </div>
      </div>
    </div>
  </div>
</div>
